module.exports = __webpack_public_path__ + "img/weixinLogo.abb98fae.png";